import React from "react";
import TowTruckCard from "./towTruckCard";

const ElectricTowTractors = () => {
  return (
    <div className="w-full mt-5">
      <h4 className="mt-8 text-xl">Elektrické tahače</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <TowTruckCard
          imgSrc="/images/ClarkOverview/clark-ctx40-70.webp"
          imgAlt="Obrázek elektrického tahače CLARK ctx40-70"
          title="CLARK série CTX40/70"
          loadCapacity="4 000 - 7 000 kg"
          drive="Elektrický"
          maxSpeed="až 17 km/h"
          link="https://clarkmheu-com.translate.goog/en/tow-trucks-and-tugger-trains/ctx40-70?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />

        <TowTruckCard
          imgSrc="/images/ClarkOverview/clark-ctr01-02.webp"
          imgAlt="Obrázek elektrického tahače CLARK ctr01-02"
          title="CLARK série CTR01/02"
          loadCapacity="1 200 - 1 600 kg"
          drive="Elektrický"
          maxSpeed="až 12 km/h"
          liftHeight="60 mm"
          link="https://clarkmheu-com.translate.goog/en/tow-trucks-and-tugger-trains/ctr01-ctr02?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
          sameHeightAsIfAdditionalInfo
        />
      </div>
    </div>
  );
};
export default ElectricTowTractors;
